/**
 * Shared Google Maps API configuration.
 *
 * The key is used for Street View embeds and Geocoding.
 * In production, move this to an environment variable (VITE_GOOGLE_API_KEY).
 */
export const GOOGLE_API_KEY =
  (import.meta as any).env?.VITE_GOOGLE_API_KEY || 'AIzaSyBFw0Qbyq9zTFTd-tUY6dZWTgaQzuU17R8';
